import { GraphQLID, GraphQLNonNull } from 'graphql'

export interface AttackEventNotesQueryArgs {
  readonly organizationId: string
  readonly attackEventUuid: string
}

export const attackEventNotesQueryArgs = {
  organizationId: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  attackEventUuid: {
    description: 'The unique ID for the attack event being queried',
    type: new GraphQLNonNull(GraphQLID)
  }
}
